import change from './change';
import hover from './hover';

const handlers = {
  change,
  hover,
  default: track => (target, data) => track(data)
};

const handle = (action, analytics) =>
  (handlers[action] || handlers.default)(analytics[action].bind(analytics));

const nameFrom = element => element.name || element.textContent;

const eventValueFrom = element => {
  try {
    return JSON.parse(element.dataset.trackValue || '{}');
  } catch (e) {
    return {};
  }
};

export default (analytics, initialData) => action =>
  function handler(event) {
    handle(action, analytics)(
      event.target,
      Object.assign({}, initialData(this, event), {
        eventAction: action,
        pageSection: this.dataset.trackSection,
        eventLabel: this.dataset.trackLabel,
        name: nameFrom(event.target),
        eventValue: eventValueFrom(this)
      })
    );
  };
